import { api } from './_http'

const VipProfiling = {
  get: () => api.get('/msvc/v1/vipprofiling/status'),
  submitAnswers: (payload) => api.post('/msvc/v1/vipprofiling/submitAnswers', payload)
}

export default VipProfiling
